export const getInitials = function (name) {
    const names = name.split(' ');
    let initials = names[0].substring(0, 1).toUpperCase();
    if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
};

export const replaceSpecialCharacters = (function () {
    const translateRe = /[áéíóúñÁÉÍÓÚÑ.]/g;
    const translate = {
        á: 'a', é: 'e', í: 'i', ó: 'o', ú: 'u', ñ: 'n', '.': '',
        Á: 'A', É: 'E', Í: 'I', Ó: 'O', Ú: 'U', Ñ: 'N'  // probably more to come
    };
    return function (s, te = undefined, t = undefined) {
        const transRe = te || translateRe;
        const trans = t || translate;
        return (s.replace(transRe, (match) => {
            return trans[match];
        }));
    };
})();

export const s4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
};

export const flattenArray = arr => Array.isArray(arr) ? [].concat(...arr.map(flattenArray)) : [arr];

export const ddmmyyyyToDate = (date: string) => {
    const parts: number[] = date.split('-').map(Number);
    return new Date(parts[2], parts[1] - 1, parts[0]);
};

/**
 * Escape RegExp special characters
 * @param {string} str
 * @returns {string}
 */
export const escapeRegExp = (str: string) =>
    str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
